module.exports = __webpack_public_path__ + "static/img/ningxia.c392b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/ningxia.png
// module id = a3H0
// module chunks = 93